import ViewPDFDesktop from './ViewPDFDesktop';
import ViewPDFMobile from './ViewPDFMobile';
import { useParams } from 'react-router-dom';

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

const ViewPDFBridge = function () {
    const { lead_id } = useParams();

    return (<>
        <ViewPDFDesktop lead_id={lead_id} />
    </>);
}

export default ViewPDFBridge;